import { DBKernUId, hasValueInErrorMessage } from "../../../Utility/Utilitys";

import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpCheckboxField,
  CmpDatePickerField001,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid"; 
import { UnitRateFlag } from "../PurchaseOrderAction";
import { 
  CmpDatePickerField001V1,
  CmpSelectFieldV1, 
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  vMediaQuery,

  onchangeCheckBox,
  sTransItemStockObj,
  xTransItemStockShow = false,
  sVirtualBin,
  sArr,
  vRdxWmsHead,
  xPaymodeEnable,
  sDocLoadingGrnType,
  sType,
  sPaymode,
  fType,
  sCurrency,
  sTax,

  fPOBarcode,
  fModalPOBarcode,

  fonSelectedGrnType,
  fGrnDate,
  fInvNo,
  fInvDate,
  fPaymode,
  fSelectedUnloading,
  fInvAmt,
  fSelectedCurrency,
  fvirtualBin,
  fTax,
  fPurchaseReturnType,
  sPurchaseReturnType,
  fOffer,
  fSourceDocNo,
  fOpenHeadCustomerSearchModalKey,
  fLocation,
  xKey,
  xFocusInput,
  vRdxuserLoc,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  inputFocus,
  sPoTerms,
  fPoTerms,
  vRdxDBKernObj,
  //customer
  xfGC_Toggle_Head_Customer_Name,
  xGC_Toggle_Head_Customer_Toggle = false,
  xGC_Toggle_Head_Customer_onKeyUp,
  xGC_Toggle_Head_Customer_SearchDropdownObj, 
  xGC_Toggle_Head_Customer_Dropdown_onChange,
  xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_Customer_GridColumns,
  xGC_Toggle_Head_Customer_GridData,
  xfGC_Toggle_Head_Customer_OnRowClick,
  xfGC_Toggle_Head_Customer_OnCellKeyDown,
  xGC_Toggle_Head_Customer_DropDown_Arr,
  //customer end
}) {

  let isImport=true;
  
  return (
    <form id="PurchaseOrderHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        sx={{ marginTop: { md: "0px", sm: "0px", xs: "10px" } }}
      >
        <Grid item xs={12} sm={12} md={4.5}>
          <Grid
            container
            spacing={1.3}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"GRN Type"} />
            </Grid> */}
            <Grid item xs={12} sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>
            {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"GRN No"} />
            </Grid> */}
            <Grid item xs={12} sm={4} md={6}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xSize="small"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>
            {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"GRN Date"} />
            </Grid> */}
            <Grid item xs={12} sm={4} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Doc.Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"InvNo/Date"} />
            </Grid> */}
            <Grid item xs={6} sm={4} md={3}>
              <CmpTextFieldV1
                xLabelText="Ref.No"
                xSize="small"
                xtabIndex={"4"}
                xValue={vRdxWmsHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={false}
                xOnChange={fInvNo}
                xError={xErrorMsg.A_RefNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefNo}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={6}>
              <CmpDatePickerField001V1
                xLabelText="Ref.Date"
                xtabIndex={"5"}
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("VendorInvAmount");
                // }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={4} md={6}>
            <GCToggleSearchV1
            xLabelText="PO Barcode"
            xtabIndex={"6"}
            xName={"POBarcode"}
            xType={"text"}
            xValue={vRdxWmsHead?.POBarcode}
            xReadOnly={xDisableBasedOnGridDataLength}
            xOnChange={fPOBarcode}
            xOnKeyUp={fModalPOBarcode}
            xonClickbtn={fModalPOBarcode}
            xError={false}
            xErrorMessage={""}
          />
            </Grid> */}
            <Grid
              item
              xs={6}
              sm={3.5}
              md={3.5}
              className={UnitRateFlag() ? "" : "hide-all-time"}
            >
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"10"}
                xLabelText="Currency"
                xValue={vRdxWmsHead.A_Curr}
                xOnChange={fSelectedCurrency}
                xName={"A_Curr"}
                xData={sCurrency}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Curr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Curr}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={2.5}>
              <CmpTextFieldV1
                xLabelText="ExRate"
                xSize="small"
                xtabIndex={"9"}
                xValue={vRdxWmsHead.A_ExRate}
                xType={"number"} // text/number/password
                xName={"A_ExRate"}
                xReadOnly={false}
                xOnChange={() => {}}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"6"}
                xLabelText="Paymode"
                xValue={vRdxWmsHead.A_PayMode}
                xOnChange={fPaymode}
                xName={"A_PayMode"}
                xData={sPaymode}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_PayMode === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PayMode}
                // xDisable={xPaymodeEnable}
                xDisable={false} //client
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid
            container
            spacing={1.3}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Vendor"} />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={0.9}>
                {!vMediaQuery && (
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <CmpTextFieldV1
                      xLabelText="Vendor"
                      xSize={"small"}
                      xValue={vRdxWmsHead.A_Party}
                      xType={"text"} // text/number/password
                      xName={"A_Party"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={xErrorMsg.A_Party === "" ? false : true}
                      xErrorMessage={xErrorMsg.A_Party}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={10} md={10} lg={10}>
                  <GCToggleSearchV1
                    xLabelText="Vendor Name"
                    xName={"GC_Toggle_Head_Customer_Name"}
                    xType={"text"}
                    xValue={vRdxWmsHead.A_PartyName}
                    // xReadOnly={vRdxWmsHead.A_RefDocTyp !== ""}
                    xReadOnly={xDisableBasedOnGridDataLength}
                    xOnChange={xfGC_Toggle_Head_Customer_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xGC_Toggle_Head_Customer_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={xErrorMsg.A_PartyName === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_PartyName}
                    xMediaQuery={false}
                    xonClickbtn={xGC_Toggle_Head_Customer_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xGC_Toggle_Head_Customer_GridData} //GCToggleSearch-grid
                    xcolumns={xGC_Toggle_Head_Customer_GridColumns} //GCToggleSearch-grid
                    xRowCellClick={xfGC_Toggle_Head_Customer_OnCellKeyDown}
                    xRowClick={xfGC_Toggle_Head_Customer_OnRowClick}
                    xToggle={xGC_Toggle_Head_Customer_Toggle} //GCToggleSearch- true/false
                    xData={xGC_Toggle_Head_Customer_DropDown_Arr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xGC_Toggle_Head_Customer_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xGC_Toggle_Head_Customer_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="7"
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* {!vMediaQuery&&  <Grid
              item
              xs={6}
              sm={4}
              md={4} 
              className={UnitRateFlag() ? "" : "hide-all-time"}
            >
              <CmpTextFieldV1
              xSize="small"
               xLabelText="Inv Amt" 
                xtabIndex={"8"}
                xValue={vRdxWmsHead.VendorInvAmount}
                xType={"number"} // text/number/password
                xName={"VendorInvAmount"}
                xReadOnly={false}
                xOnChange={fInvAmt}
                xError={xErrorMsg.VendorInvAmount === "" ? false : true}
                xErrorMessage={xErrorMsg.VendorInvAmount}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
            </Grid>}
            */}

            <Grid
              item
              xs={6}
              sm={4}
              md={4}
              className={UnitRateFlag() ? "" : "hide-all-time"}
            >
              <CmpSelectFieldV1
                xLabelText="Type"
                xSize="small"
                xValue={vRdxWmsHead.Type}
                xOnChange={fType}
                xName={"Type"}
                xData={sType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Type === "" ? false : true}
                xErrorMessage={xErrorMsg.Type}
                xDisable={false}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={4}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"11"}
                xLabelText="Location"
                xValue={vRdxWmsHead.A_Loc}
                xOnChange={fLocation}
                xName={"A_Loc"}
                xData={vRdxuserLoc}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Loc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Loc}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={4}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"12"}
                xLabelText="Tax Type"
                xValue={vRdxWmsHead.TaxType}
                xOnChange={fTax}
                xName={"TaxType"}
                xData={sTax}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.TaxType === "" ? false : true}
                xErrorMessage={xErrorMsg.TaxType}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>

            {DBKernUId("INV02_PAYTERMS_VISIBLE") && (
              <Grid item xs={6} sm={3.5} md={3.5}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"10.1"}
                  xLabelText="PoTerms"
                  xValue={vRdxWmsHead.PoTerms}
                  xOnChange={fPoTerms}
                  xName={"PoTerms"}
                  xData={sPoTerms}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.PoTerms === "" ? false : true}
                  xErrorMessage={xErrorMsg.PoTerms}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={1.5}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 2 }}
            sx={{ marginTop: { md: 0, sm: "8px", xs: "8px" } }}

            // sx={{ flexDirection: "column", alignItems: "start" }}
            // className="ps-3"
          >
            <Grid item xs={4} sm={2} md={2}>
              <CmpCheckboxField
                xtabIndex={"14"}
                xChecked={vRdxWmsHead?.Tax === "Y"}
                xOnChange={onchangeCheckBox}
                xDisabled={true}
                xName={"Tax"}
                xNameField={"Tax"}
                xError={xErrorMsg.Tax === "" ? false : true}
                xErrorMessage={xErrorMsg.Tax}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={4} sm={2} md={2}>
              <CmpCheckboxField
                xtabIndex={"14"}
                xChecked={vRdxWmsHead?.TaxGross === "Y"}
                xOnChange={onchangeCheckBox}
                xDisabled={xDisableBasedOnGridDataLength}
                xName={"TaxGross"}
                xNameField={"Tax/Gross"}
                xError={xErrorMsg.TaxGross === "" ? false : true}
                xErrorMessage={xErrorMsg.TaxGross}
                sales_onvoice_check_box="start"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
